module.exports = __webpack_public_path__ + "static/img/ssnx.fcabfd2d.png";